// React
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';

// Global Context
import { GlobalContext } from '../../contexts/Global';

// Components
import Topbar from '../../components/Topbar/Topbar';

export default function ProtectedRoute({ children }) {
    const { user } = useContext(GlobalContext);

    if (!user) {
        return <Navigate to="/" replace />
    }
    else {
        return (
            <>
                <Topbar />
                <div id="middle">
                    { children }
                </div>
            </>
        )
    }
};
